import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";

import SmoothScroll from "@/lib/SmoothScroll";
import Cursor from "@/lib/Cursor";
import ScrollToTop from "@/lib/ScrollToTop";
import WhatsAppButton from "@/components/WhatsAppButton";

import Home from "@/pages/Home";
import Journeys from "@/pages/Journeys";
import JourneyDetail from "@/pages/JourneyDetail";
import SignatureJourney from "@/pages/SignatureJourney";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import LensOfJeetAman from "@/pages/LensOfJeetAman";
import Experiences from "@/pages/Experiences";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <SmoothScroll>
            <ScrollToTop />
            <Cursor />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/journeys" element={<Journeys />} />
              <Route path="/journeys/:slug" element={<JourneyDetail />} />
              <Route path="/signature-journey" element={<SignatureJourney />} />
              <Route path="/lens-of-jeet-aman" element={<LensOfJeetAman />} />
              <Route path="/experiences" element={<Experiences />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
            <WhatsAppButton phone="919650595152" />
          </SmoothScroll>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
